module.exports = __webpack_public_path__ + "static/media/sliders-v.d8c4562a.svg";